import {Howl} from "howler";
import * as PIXI from "pixi.js";
import data from "../configs/data";
import {Utils} from "../Utils";

export class ChipsStack extends PIXI.Container {

    private tokenValuesTextures: Array<PIXI.Texture> = [];
    private tokenValues: Array<number>;
    private previousStackValue = 0;
    private firstTokenSound: Howl;
    private nextTokensSound: Howl;
    private readonly TOKENS_OFFSET = 2;
    // Smallest chip is 0.001 (extremely small bets), so keep three decimals when splitting a value into chips.
    private readonly VALUE_PRECISION = 3;
    private readonly DEFAULT_ANCHOR_POINT: any = new PIXI.Point(0.5, 0.5);
    private readonly CHIPS_STACKS_SCALE = new PIXI.Point(0.9, 0.9);

    constructor(tokenValuesPath: Array<string>, tokenValues: Array<number>) {
        super();
        this.scale = this.CHIPS_STACKS_SCALE;
        for (let i = 0; i < tokenValuesPath.length; i++) {
            this.tokenValuesTextures.push(PIXI.Texture.fromFrame(tokenValuesPath[i]));
        }
        this.tokenValues = tokenValues;
        this.firstTokenSound = new Howl({
            src: [data.audios.firstChipPut],
        });
        this.nextTokensSound = new Howl({
            src: [data.audios.nextChipPut],
        });
    }

    public setStack(value: number): void {
        let tokensAmount = 0;
        let currentTokenOffset = this.TOKENS_OFFSET;
        let sprite;
        let remainingValue = value;

        if (value !== 0) {
            if (this.previousStackValue === 0) {
                this.firstTokenSound.play();
            } else {
                this.nextTokensSound.play();
            }
        }

        this.previousStackValue = value;

        this.removeChildren();

        for (let i = 0; i < this.tokenValues.length; i++) {
            // Round the quotient before flooring: e.g. 0.3 / 0.1 === 2.9999999999999996 in floating point.
            tokensAmount = Math.floor(Utils.roundWithPrecision(remainingValue / this.tokenValues[i], 6));
            remainingValue -= tokensAmount * this.tokenValues[i];
            remainingValue = Utils.roundWithPrecision(remainingValue, this.VALUE_PRECISION);
            for (let j = 0; j < tokensAmount; j++) {
                sprite = new PIXI.Sprite(this.tokenValuesTextures[i]);
                sprite.position.y = currentTokenOffset;
                sprite.anchor = this.DEFAULT_ANCHOR_POINT;
                currentTokenOffset -= this.TOKENS_OFFSET;
                this.addChild(sprite);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/userInterface/ChipsStack.ts